import gql from "graphql-tag";
import { cartItemFields, cartSupplyGroupFields } from "@/gql/cart.fragments";

export const earlyBirdSupplyQuery = gql`
  query earlyBirdSupply($productId: ID!, $supplyId: ID) {
    earlyBirdSupply(productId: $productId, supplyId: $supplyId) {
      supply {
        id
        receiptDate
        freeValue
        storage {
          name
        }
      }
      availableUnits
      daysUntilReceipt
      reservationOptions {
        reservationType
        measureName
        measureRatio
        cashUnitPriceUsd
        cashlessUnitPriceUsd
        priceMode
        priceSource
      }
    }
  }
`;

export const cartQuery = gql`
  query cart {
    cart {
      inStockItems {
        ...CartItemFields
      }
      supplyGroups {
        ...CartSupplyGroupFields
      }
      sum {
        value
        currency {
          symbol
          code
        }
      }
      paymentMethod
    }
  }
  ${cartItemFields}
  ${cartSupplyGroupFields}
`;
